import React, { Fragment, useEffect, useState } from "react"

import PropTypes from "prop-types"

import "./index.less"
import { Button, Input, Modal, Table, Select, Popover, Tooltip } from "antd"
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons"
import { isArray, map, uniqBy, get } from "lodash-es"

const { Option } = Select

const AddCollaboratorsLeadersSegments = (props) => {
  const [inputSearch, setInputSearch] = useState("")
  const [selectionType, setSelectionType] = useState("checkbox")
  const [filteredInfo, setFilteredInfo] = useState(null)
  // const [filteredData, setFilteredData] = useState([])

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      props.setStateFrom("employeesSelected", selectedRows)
    },
    getCheckboxProps: (record) => {
      return {
        // disabled: validateDisable(record),
        key: record.employee ? record.employee.id_employee : record.id_employee,
      }
    },
    selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
    checkStrictly: false,
  }

  const renderInputSearch = () => {
    return (
      <Input
        placeholder="Buscar..."
        value={inputSearch}
        onChange={(e) => setInputSearch(e.target.value)}
        style={{ width: 200, height: 32 }}
        suffix={
          inputSearch ? (
            <CloseCircleOutlined
              style={{
                cursor: "pointer",
                color: "#FFF",
                backgroundColor: "#979797",
                borderRadius: "50%",
              }}
              onClick={() => setInputSearch("")}
            />
          ) : (
            <SearchOutlined
              style={{
                cursor: "pointer",
                color: "#A7A3A3",
                borderRadius: "50%",
              }}
            />
          )
        }
      />
    )
  }

  const footer = () => {
    const disabledButton = props.employeesSelected.length === 0
    let styleButton = {}
    if (disabledButton) {
      styleButton = {
        backgroundColor: "#C4C4C4",
        borderColor: "#C4C4C4",
        color: "#FFF",
      }
    } else {
      styleButton = {
        backgroundColor: "#1890ff",
        borderColor: "#1890ff",
        color: "#FFF",
      }
    }
    return [
      <Button
        key="back"
        className="cancelButton"
        onClick={() =>
          props.setStateFrom("modalAddCollaboratorsLeadershipSegments", false)
        }>
        Cancelar
      </Button>,
      <Button
        key="submit"
        disabled={disabledButton}
        loading={props.isLoadingAddCollaborators}
        style={styleButton}
        onClick={() => props.addCollaborators()}
        type="primary">
        Agregar
      </Button>,
    ]
  }

  const renderTable = () => {
    let filterSegments = []
    props.listPossibleRecipients.map((row) => {
      row.segments.map((segment) => {
        filterSegments.push({
          text: segment.name,
          value: segment.id_segment,
        })
      })
    })
    filterSegments = uniqBy(filterSegments, "value")

    const filteredInfoAux = filteredInfo || {}

    const columns = [
      {
        title: "Equipo",
        dataIndex: "team",
        key: "team",
        sorter: (a, b) =>
          get(a, "employee.full_name", a.full_name).localeCompare(
            get(b, "employee.full_name", b.full_name)
          ),
        // a.employee.full_name.localeCompare(b.employee.full_name),
        render: (text, record) => {
          if (record.employee) {
            return (
              <span>
                Equipo de {record.employee.first_name}{" "}
                {record.employee.last_name}
              </span>
            )
          }
          return (
            <span>
              {record.first_name} {record.last_name}
            </span>
          )
        },
      },
      {
        title: "División",
        dataIndex: "name_division",
        key: "name_division",
        render: (text, record) => (
          <span
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              width: "102px",
              display: "inline-block",
            }}>
            {record.employee ? record.employee.name_division : <></>}
          </span>
        ),
      },
      {
        title: "Segmento(s)",
        dataIndex: "segments",
        width: "152px",
        filters: filterSegments,
        filteredValue: filteredInfoAux.segments || null,
        onFilter: (value, record) =>
          record.segments.some((elem) => elem.id_segment === value),
        key: "segments",
        render: (text, record) => {
          return (
            <Tooltip
              title={() => {
                let segmentsName = []
                for (let i = 0; i < record.segments.length; i++) {
                  segmentsName.push(
                    <p
                      style={{
                        margin: 0,
                        // maxWidth: "150px",
                        // whiteSpace: "nowrap",
                        // overflow: "hidden",
                        // textOverflow: "ellipsis",
                      }}>
                      {i + 1}. {record.segments[i].name}
                    </p>
                  )
                }
                return <>{segmentsName}</>
              }}>
              <span
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  width: "140px",
                  display: "inline-block",
                }}>
                {record.segments ? (
                  record.segments.map((segment, index) => {
                    return index === record.segments.length - 1
                      ? segment.name
                      : `${segment.name}, `
                  })
                ) : (
                  <></>
                )}
              </span>
            </Tooltip>
          )
        },
      },
    ]

    const onChange = (pagination, filters, sorter, extra) => {
      setFilteredInfo(filters)
    }
    let dataFiltered = props.listPossibleRecipients

    let copyData = [...dataFiltered]
    let newData = []
    if (copyData.length > 0) {
      newData = copyData.map((item) => {
        item.employee.id_employee = `${item.employee.id_employee}-leader`
        item.children = [...item.employee.team_array]
        item.children.forEach((element) => {
          element.id_recipient_leader = item.employee.id_recipient_leader
        })
        return item
      })
    }
    let finalData = [...newData]
    if (inputSearch !== "") {
      finalData = newData.filter((item) => {
        if (
          item.employee.team_array.some((element) => {
            return element.full_name
              .toLowerCase()
              .includes(inputSearch.toLowerCase())
          })
        ) {
          item.children = item.children.filter((ele) => {
            return ele.full_name
              .toLowerCase()
              .includes(inputSearch.toLowerCase())
          })
          return item
        }
      })
    }

    return (
      <Table
        rowKey={(record) => {
          if (record.employee) {
            return record.employee.id_employee
          }
          return record.id_employee
        }}
        rowSelection={{
          type: selectionType,
          ...rowSelection,
        }}
        onChange={onChange}
        scroll={{ y: 390 }}
        size="small"
        bordered
        columns={columns}
        dataSource={finalData}
        pagination={{
          defaultPageSize: 10,
          pageSizeOptions: [10, 20, 50, 100],
          showSizeChanger: true,
          size: "default",
        }}
      />
    )
  }

  return (
    <Modal
      width={740}
      className="AddCollaboratorsLeadersSegmentsModal"
      style={{ top: 110 }}
      title="Agregar destinatarios"
      closable={false}
      visible={props.modalOpen}
      footer={footer()}>
      <div className="AddCollaboratorsLeadersSegmentsModal-Content">
        <div className="AddCollaboratorsLeadersSegmentsModal-Content-Header">
          <span>
            Selecciona los equipos o destinatarios que deseas agregar a la
            medición:
          </span>
          {renderInputSearch()}
        </div>
        <div className="AddCollaboratorsLeadersSegmentsModal-Content-Table">
          {renderTable()}
        </div>
      </div>
    </Modal>
  )
}

AddCollaboratorsLeadersSegments.propTypes = {
  setStateFrom: PropTypes.func,
  modalOpen: PropTypes.bool,
  listPossibleRecipients: PropTypes.array,
  employeesAndSurveys: PropTypes.array,
  employeesSelected: PropTypes.array,
  addCollaborators: PropTypes.func,
  isLoadingAddCollaborators: PropTypes.bool,
}

export default AddCollaboratorsLeadersSegments
